import { ACTIONS } from '../Constants';

const initialState = {
    byId: {},
    teamsUnsavedFlag: false,
};

const teams = (state = initialState, action) => {
    let newById;
    let reduced;
    switch (action.type) {
        case ACTIONS.GET_MANY_TEAMS: {
            const { teams = [] } = action.payload;

            reduced = teams.reduce((prev, team) => {
                prev[team._id] = team;
                return prev;
            }, {});
            newById = {
                ...state.byId,
                ...reduced
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_TEAM: {
            const { team } = action.payload;
            const updatedTeam = { ...state.byId[team[0]._id], ...team[0] };
            newById = {
                ...state.byId,
                [team[0]._id]: updatedTeam
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.GET_TEAM_ADMIN: {
            const { team } = action.payload;
            newById = {
                ...state.byId,
                [team._id]: team
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.PUT_TEAM_SUCCESS:
        case ACTIONS.POST_TEAM_SUCCESS: {
            const { team } = action.payload;
            newById = {
                ...state.byId,
                [team._id]: team
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.PUT_TEAM_ASSIGNMENT: {
            const { team } = action.payload;
            newById = {
                ...state.byId,
                [team._id]: team
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.PUT_TEAMS_LOCAL: {
            const { teams } = action.payload;
            const newById = {
                ...teams.byId
            };
            return {
                ...state,
                byId: newById
            };
        }
        case ACTIONS.DELETE_TEAM_SUCCESS: {
            const { id } = action.payload;
            newById = { ...state.byId };
            const newFilteredById = { ...state.filteredById };
            if (id in newById) {
                delete newById[id];
            }
            if (id in newFilteredById) {
                delete newFilteredById[id];
            }
            return {
                ...state,
                byId: newById,
                filteredById: newFilteredById
            };
        }
        case ACTIONS.REMOVE_TEAM_MEMBERS_SUCCESS:
        case ACTIONS.ADD_TEAM_MEMBERS_SUCCESS: {
            const { updatedUserProfiles, teamId } = action.payload;
            const teamToUpdate = { ...state.byId[teamId] };

            if (!teamToUpdate.members) {
                teamToUpdate.members = [];
            }

            const teamMemberIds = teamToUpdate.members.map((member) => member._id);

            updatedUserProfiles.forEach((profile) => {
                const index = teamMemberIds.indexOf(profile._id);
                const teamIdsArr = profile.teams.map((object) => object.teamId);
                if (teamIdsArr.indexOf(teamId) > -1 && index < 0) {
                    teamToUpdate.members.push(profile);
                } else if (index > -1) {
                    teamToUpdate.members.splice(index, 1);
                }
            });
            teamToUpdate.memberCount = teamToUpdate.members.length;

            const newById = {
                ...state.byId,
                [teamId]: teamToUpdate
            };

            return {
                ...state,
                byId: newById
            };
        }

        case ACTIONS.SET_UNSAVED_CHANGES: {
            const { teamsUnsavedFlag } = action.payload;
            return {
                ...state,
                teamsUnsavedFlag
            }
        }

        default:
            return state;
    }
};

export default teams;
